import OstSipCalculatorV2 from "./components/OstSipCalculatorV2";

export default function App() {
  return <OstSipCalculatorV2 />;
}
